<template>
  <!--begin::Modal - View Users-->
  <div>
    <div
      class="modal fade"
      id="kt_modal_view_users"
      tabindex="-1"
      aria-hidden="true"
      ref="viewCustomerModalRef"
    >
      <!--begin::Modal dialog-->
      <div class="modal-dialog modal-dialog-centered mw-550px">
        <!--begin::Modal content-->
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header border-0 justify-content-between">
            <!--begin::Close-->
            <h1 class="modal-title">เลือกลูกค้า</h1>
            <div
              class="btn btn-sm btn-icon btn-active-color-primary"
              data-bs-dismiss="modal"
            >
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--begin::Modal header-->

          <!--begin::Modal body-->
          <div class="modal-body py-0">
            <!--begin::Heading-->
            <!--end::Heading-->
            <loading
              v-model:active="isLoading"
              :can-cancel="true"
              :is-full-page="false"
            />
            <form
              data-kt-search-element="form"
              class="w-100 position-relative mb-5"
              autocomplete="off"
            >
              <el-input
                placeholder="Type something"
                prefix-icon="bi bi-search fs-4 ps-1 "
                v-model="searchText"
                clearable
              >
              </el-input>
            </form>
            <!--begin::Users-->
            <div class="scroll-y h-375px">
              <!--begin::List-->

              <div class="list-group list-group-flush list-group-item-action">
                <div
                  v-for="(customer, index) in customersFilter"
                  :key="index"
                  class="list-group-item list-group-item-action"
                  style="cursor: pointer"
                  @click="() => onSelect(customer)"
                >
                  <!--begin::User-->
                  <div class="d-flex flex-stack py-3">
                    <!--begin::Details-->
                    <div class="d-flex align-items-center">
                      <!--begin::Avatar-->

                      <!--end::Avatar-->

                      <!--begin::Details-->
                      <div>
                        <!--begin::Name-->
                        <a
                          style="cursor: pointer"
                          class="
                            d-flex
                            align-items-center
                            fs-5
                            fw-bolder
                            text-dark text-hover-primary
                          "
                        >
                          {{ customer.customerName }}
                        </a>
                        <!--end::Name-->

                        <!--begin::Email-->
                        <div class="fw-bold text-gray-400">
                          {{ customer.customerAddress }}
                        </div>
                        <!--end::Email-->
                      </div>
                      <!--end::Details-->
                    </div>
                    <!--end::Details-->

                    <!--begin::Stats-->
                    <div class="d-flex">
                      <!--begin::Sales-->
                      <div class="text-end">
                        <div class="fs-5 text-dark">
                          {{ customer.customerMobile }}
                        </div>

                        <!-- <div class="fs-7 text-muted">Sales</div> -->
                      </div>
                      <!--end::Sales-->
                    </div>
                    <!--end::Stats-->
                  </div>
                  <!--end::User-->
                </div>
              </div>
              <!--end::List-->
            </div>
            <!--end::Users-->
          </div>
          <!--end::Modal body-->
          <div class="modal-footer border-0 justify-content-between">
            <div>
              <button
                class="btn btn-light-primary"
                @click="showAddCustomerModal"
              >
                สร้าง
              </button>
            </div>
          </div>
        </div>
        <!--end::Modal content-->
      </div>
      <!--end::Modal dialog-->
    </div>
    <add-customer-modal
      ref="addCustomerModal"
      @refreshdata="getCustomers"
    ></add-customer-modal>
  </div>
  <!--end::Modal - View Users-->
</template>

<script>
import { Modal } from "bootstrap";
import ApiService from "@/core/services/ApiService";
import AddCustomerModal from "@/components/modals/forms/AddCustomerModal";
import Loading from "vue-loading-overlay";

export default {
  components: {
    AddCustomerModal,
    Loading,
  },
  data() {
    return {
      customers: [],
      customerModal: null,
      searchText: null,
      isLoading: false,
    };
  },
  computed: {
    customersFilter() {
      const regex = new RegExp(this.searchText ? this.searchText.trim() : "", "gi");
      return this.customers.filter(
        (customer) =>
          customer.customerName.search(regex) >= 0 ||
          customer.customerMobile.search(regex) >= 0
      );
    },
  },
  mounted() {
    this.customerModal = new Modal(this.$refs.viewCustomerModalRef);
  },
  methods: {
    show() {
      this.customerModal.show();
      this.getCustomers();
    },
    hide() {
      this.customerModal.hide();
    },
    getCustomers() {
      this.isLoading = true;
      ApiService.query("customers")
        .then(({ data }) => {
          this.customers = data;
        })
        .catch((err) => console.log(err.response))
        .finally(() => (this.isLoading = false));
    },
    showAddCustomerModal() {
      this.$refs["addCustomerModal"].show();
    },
    onSelect(customer) {
      this.$emit("select", customer);
      this.hide();
    },
  },
};
</script>
